import React, { useEffect } from 'react';
import { Grid, GridRow } from '@naf/grid';
import { useDispatch } from 'react-redux';
import useSelector from '@redux/typedHooks';
import { actions as guides } from '@redux/modules/consumerGuides';
import { useAuth0Token } from '@hooks/useAuth0Token';
import { ArticleLoader } from '@components/skeleton-loaders/ArticleLoader';
import { ConsumerTestCard } from '@pages/ConsumerTestGuide/Components/ConsumerTestCard/ConsumerTestCard';
import { getPlaceholderList } from '@utils/getPlaceholderList';
import * as S from './Styles';

export const ConsumerGuideBlock = () => {
  const { simpleToken } = useAuth0Token();
  const dispatch = useDispatch();
  const { items } = useSelector((state) => state.consumerGuides.data);
  const isUpdating = useSelector((state) => state.consumerGuides.isUpdatingGuide);
  const hasToken = !!simpleToken;

  useEffect(() => {
    dispatch(guides.getConsumerGuides.request(undefined, undefined));
  }, [dispatch, hasToken]);

  if (isUpdating && (!items || items.length === 0)) {
    return (
      <Grid>
        <GridRow>
          {getPlaceholderList(6).map((i) => (
            <S.CardGridWrapper s="12" m="12" l="4" xl="4" key={`consumerTestCard-placeholder-item-${i}`}>
              <ArticleLoader />
            </S.CardGridWrapper>
          ))}
        </GridRow>
      </Grid>
    );
  }

  return <GridRow>{items && items.map((item) => <ConsumerTestCard key={item.slug} test={item} />)}</GridRow>;
};
